import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_ROUTES } from './shared/enums';
import { authGuard, superUserGuard } from './core/guards';
import { LayoutComponent } from './shared/components';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/onboarding/onboarding.module').then(m => m.OnboardingModule),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: APP_ROUTES.HOME,
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule),
      },
      {
        path: APP_ROUTES.TESTS,
        // blockedAccessGuard is applied inside TestResultsRoutingModule on the
        // `new` / `new/:id` child routes only — the rest of the tests area
        // (list, reports) stays reachable after trial expiry (MVP-10).
        loadChildren: () => import('./features/test-results/test-results.module').then(m => m.TestResultsModule),
      },
      {
        path: APP_ROUTES.SETTINGS,
        loadChildren: () =>
          import('./features/profile-settings/profile-settings.module').then(m => m.ProfileSettingsModule),
      },
      {
        path: APP_ROUTES.ADMIN,
        canActivate: [superUserGuard],
        loadChildren: () => import('./features/super-user/super-user.module').then(m => m.SuperUserModule),
      },
    ],
  },
  { path: '**', redirectTo: APP_ROUTES.HOME },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
